import useUpgradesStore from "@/store/useUpgradesStore";
import { formatPercent } from "@/utils/format";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class MillBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.MILL;

	public get description(): string {
		return super.description.replace(
			"{percent}",
			formatPercent(
				(this.config.production.get(
					ResourceType.PRODUCTION_RESOURCE_MULTIPLIER,
				)! as number) - 1,
			),
		);
	}

	public get requirements(): Map<ResourceType, number> {
		const requirements = new Map<ResourceType, number>(super.requirements);

		// Apply upgrades
		let connectionRequirement =
			(requirements.get(ResourceType.SETTLEMENT_CONNECTION) as number) ||
			0;
		if (
			useUpgradesStore().getCurrentLevelById(UpgradeIds.millers_guild) > 0
		) {
			connectionRequirement = 0;
		}
		requirements.set(
			ResourceType.SETTLEMENT_CONNECTION,
			connectionRequirement,
		);

		return requirements;
	}
}

export default MillBuildingTileEntity;
